<template>
    <div>

        <div class="padding-v-4 padding-h-2 flex column justify-center align-center job-search">
            <div class="flex column-tablet w-100 margin-t-2 gap-2">
                <div class="flex column col-30">
                    <label for="jobs-input" class="text-s text-color-weak">Search for a job</label>
                    <input id="jobs-input" class="nc-input" placeholder="Ex: Software engineer" v-model="searchString">
                </div>
                <div class="flex column col-30">
                    <label for="location-select" class="text-s text-color-weak">Location</label>
                    <select id="location-select" class="nc-select" v-model="selectedLocation">
                        <option>All locations</option>
                        <option value="all">All locations</option>
                        <template v-for="(location, slug) in locations">
                            <option :value="slug">{{ location }}</option>
                        </template>
                    </select>
                </div>
                <div class="flex column col-30">
                    <span class="text-s text-color-weak">&nbsp;</span>
                    <a :href="searchJobLink" class="btn-primary w-100">Search jobs</a>
                </div>
            </div>
        </div>

    </div>
</template>

<script setup>
import {ref, onBeforeMount, computed} from 'vue';

const locations = ref([]);
const selectedLocation = ref('all')
const searchString = ref('')
const getLocations = async () => {
    try {
        const res = await fetch(`/api/get-all-locations`)
        const data = await res.json()

        locations.value = data.data
    } catch (err) {
        locations.value = []
    }
}

const searchJobLink = computed(() => {

    const params = new URLSearchParams()

    if (selectedLocation.value !== 'all') {
        params.append('location', selectedLocation.value)
    }

    if (searchString.value !== '') {
        params.append('q', searchString.value)
    }

    return `/careers/open-positions?${params}`
})

onBeforeMount(() => {
    getLocations()
})

</script>
